<template>
  <input
    class="form-control col-md-12"
    type="text"
    v-model="value"
    :id="getFieldID(schema)"
    :disabled="disabled"
    :maxlength="schema.maxlength"
    :placeholder="schema.placeholder"
    :readonly="schema.readonly"
  >
</template>

<script>
import { abstractField } from 'vue-form-generator';


export default {
  mixins: [abstractField],
  watch: {
    value(val) {
      const block = this.schema.block;
      if (typeof this.value === 'string' && block) {
        this.$set(this, 'value', val.replace(block, ''));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldRegex.vue